import { render, staticRenderFns } from "./stepper.vue?vue&type=template&id=1884e61a&scoped=true"
import script from "./stepper.vue?vue&type=script&lang=js"
export * from "./stepper.vue?vue&type=script&lang=js"
import style0 from "./stepper.vue?vue&type=style&index=0&id=1884e61a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1884e61a",
  null
  
)

export default component.exports